import React, { useMemo } from "react";
import s from "../mobile.module.css";
import { Button, Checkbox, Collapse, Input, Card, Typography } from "antd";
import {
    ToolOutlined,
    ExperimentOutlined,
    CloudOutlined,
    SettingOutlined,
    QuestionOutlined,
    DollarOutlined
} from '@ant-design/icons';
import '../mobile.css'

const { Panel } = Collapse;
const { Text } = Typography;

// Конфигурация категорий работ
const WORK_CATEGORIES = [
    { key: 1, title: "Основные работы", icon: <ToolOutlined />, type: 1 },
    { key: 2, title: "Химия и удобрения", icon: <ExperimentOutlined />, type: 2 },
    { key: 3, title: "Полив", icon: <CloudOutlined />, type: 3 },
    { key: 4, title: "Автополив", icon: <SettingOutlined />, type: 4 },
    { key: 5, title: "Остальное", icon: <QuestionOutlined />, type: 5 },
    { key: 6, title: "Финансы", icon: <DollarOutlined />, type: 6 }
];

const Report = ({ check, setCheck, setwork, reportsTemp, close }) => {
    /**
     * Обработчик изменения состояния checkbox
     */
    const handleCheckboxChange = (workId) => {
        const updatedCheck = check.map(item =>
            Number(item.id) === Number(workId)
                ? { ...item, checked: !item.checked }
                : item
        );
        setCheck(updatedCheck);
        setwork();
    };

    /**
     * Обработчик изменения значения input
     */
    const handleInputChange = (workId, value) => {
        const updatedCheck = check.map(item =>
            Number(item.id) === Number(workId)
                ? { ...item, inputVal: value }
                : item
        );
        setCheck(updatedCheck);
    };

    /**
     * Генерация элементов для каждой категории работ
     */
    const renderWorkCategory = (categoryType) => {
        const categoryWorks = reportsTemp
            .filter(work => Number(work.type) === categoryType)
            .map(work => {
                const workData = check.find(item => Number(item.id) === Number(work.id));
                if (!workData) return null;

                return (
                    <Card
                        key={work.id}
                        size="small"
                        className={s.workCard}
                        style={{ marginBottom: 12 }}
                    >
                        <div className={s.workItem}>
                            <Checkbox
                                checked={workData.checked}
                                onChange={() => handleCheckboxChange(work.id)}
                                className={s.workCheckbox}
                            >
                                <Text strong>{work.name}</Text>
                            </Checkbox>

                            {Number(work.input) !== 0 && workData.checked && (
                                <Input
                                    value={workData.inputVal}
                                    placeholder={workData.inputName || "Введите значение"}
                                    onChange={(e) => handleInputChange(work.id, e.target.value)}
                                    className={s.workInput}
                                    style={{ marginTop: 8 }}
                                />
                            )}
                        </div>
                    </Card>
                );
            })
            .filter(Boolean);

        return categoryWorks.length > 0 ? categoryWorks : (
            <Text type="secondary" style={{ padding: 8 }}>
                Нет работ в этой категории
            </Text>
        );
    };

    /**
     * Активные категории (имеющие работы)
     */
    const activeCategories = useMemo(() => {
        return WORK_CATEGORIES.filter(category =>
            reportsTemp.some(work => Number(work.type) === category.type)
        );
    }, [reportsTemp]);

    return (
        <div className={s.reportContainer}>
            <div className={s.reportHeader}>
                <Text strong>Выберите выполненные работы</Text>
            </div>

            <Collapse
                accordion
                ghost
                defaultActiveKey={['1']}
                className={s.workCollapse}
            >
                {activeCategories.map(category => (
                    <Panel
                        key={category.key}
                        header={
                            <div className={s.panelHeader}>
                                {category.icon}
                                <Text style={{ marginLeft: 8 }}>{category.title}</Text>
                            </div>
                        }
                    >
                        <div className={s.categoryContent}>
                            {renderWorkCategory(category.type)}
                        </div>
                    </Panel>
                ))}
            </Collapse>
        </div>
    );
};

export default Report;